import { getCookie } from '../components/common/cookie'
import { getParameterByName } from '../components/common/utils'
import config from '../services/config.json'

export const isProduction = () =>
  document.location.origin === config.URL_prod || document.location.origin === config.URL_prod_tw

export const debug = (...args) => {
  if (!isProduction()) console.log(...args)
}

export const getLanguage = () => getCookie('language')

export const getReferer = () =>
  getParameterByName('referer') || encodeURIComponent(window.location.href.replace(window.location.origin, ''))

export const CLUB_URL_DOMAIN = isProduction() ? config.URL_CLUB_prod : config.URL_CLUB_qa
